<div class="version-info">
  <p class="version-label">Current Version</p>
  <p class="version-number">{{ version || 'Unknown' }}</p>
</div>

@if (!isServiceWorkerEnabled) {
  <p class="service-worker-warning">
    <ion-text color="warning">
      Service Worker is not enabled. Auto-updates require HTTPS.
    </ion-text>
  </p>
}

@if (updateAvailable) {
  <div class="update-available">
    <span class="update-available-label">Update available</span>
  </div>
}

<div class="button-container">
  <crowdctrl-loading-button
    (pressed)="checkForUpdates()"
    [loading]="isChecking"
    [loadingText]="'Checking for updates...'"
    [disabled]="!isServiceWorkerEnabled"
    expand="block"
    fill="outline"
    color="primary"
  >
    Check for Updates
  </crowdctrl-loading-button>
</div>
